import React from "react";

const Highlights = ({ className = "", highlightsData = [] }) => (
    <div className={`highlights ${className}`}>
        {highlightsData
            ? highlightsData.map(({ className, highlight }, index) => (
                  <div key={index} className={`flex highlight ${className}`}>
                      <span className="text-14 fw-600 flex align-center justify-center number">{index + 1}</span>
                      <span className="text-14 fw-500 flex align-center text">{highlight}</span>
                  </div>
              ))
            : null}
    </div>
);

export default Highlights;
